import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import {
  calculateDefaultUnit,
  changeAllowSetDefaultUnit,
} from '../../../common/selectCurrencyUnit/slice'
import ScoreCompanyService from '../core/service'

const screen = SCREEN.SCORE

export const getHighlight = createAsyncThunk(
  'companyAnalysis/scoreCompany/getHighlight',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await ScoreCompanyService.getHightLight(params)
      if (response.success) {
        dispatch(
          calculateDefaultUnit({
            screen,
            getValues: () => [
              {
                value: response.data.totalTradeCreditLimit,
                year: new Date(response.data?.publicDateId).getFullYear(),
              },
            ],
          }),
        )
        dispatch(changeAllowSetDefaultUnit({ screen, value: false }))
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
